(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-counter-discount-custom"] && !Shopify.designMode) return;
  try {
    
    $(document).ready(function() {
    function startCountdown(element) {
      const timerElement = $(element).find('.timer');
      const hoursElement = timerElement.find('.hours');
      const minutesElement = timerElement.find('.minutes');
      const secondsElement = timerElement.find('.seconds');
      const labelsElement = $(element).find('.labels');

      // Get initial values from Shopify customizer settings for this section
      let hours = parseInt(hoursElement.text());
      let minutes = parseInt(minutesElement.text());
      let seconds = parseInt(secondsElement.text());

      // Start the countdown timer for this section
      const countdownInterval = setInterval(function() {
        seconds--;

        if (seconds < 0) {
          minutes--;
          seconds = 59;
        }

        if (minutes < 0) {
          hours--;
          minutes = 59;
        }

        if (hours < 0) {
          // Countdown completed for this section
          clearInterval(countdownInterval);
          timerElement.text('Timer Expired');
          labelsElement.hide(); // Hide labels when the countdown expires
        } else {
          // Update the display for this section
          hoursElement.text(hours.toString().padStart(2, '0'));
          minutesElement.text(minutes.toString().padStart(2, '0'));
          secondsElement.text(seconds.toString().padStart(2, '0'));
        }
      }, 1000);
    }

    $('.countdown-timer').each(function() {
      startCountdown(this);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["count-timer-two-cart"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
  const timerElement = $('.cart-page-custm-count .custom-timer-cout');
  const hoursElement = timerElement.find('.hours-custm');
  const minutesElement = timerElement.find('.minutes-custom');
  const secondsElement = timerElement.find('.seconds-custom');

  // Function to display the time
  function displayTime(hours, minutes, seconds) {
    hoursElement.text(hours.toString().padStart(2, '0'));
    minutesElement.text(minutes.toString().padStart(2, '0'));
    secondsElement.text(seconds.toString().padStart(2, '0'));
  }

  // Get initial values from localStorage or Shopify customizer settings
  let hours = parseInt(localStorage.getItem('countdownHours'));
  let minutes = parseInt(localStorage.getItem('countdownMinutes'));
  let seconds = parseInt(localStorage.getItem('countdownSeconds'));

  // If localStorage is empty, initialize from customizer
  if (isNaN(hours) || isNaN(minutes) || isNaN(seconds)) {
    hours = parseInt(hoursElement.text());
    minutes = parseInt(minutesElement.text());
    seconds = parseInt(secondsElement.text());
  } else {
    // If localStorage has values, display the stored time immediately
    displayTime(hours, minutes, seconds);
  }

  // Start the countdown timer
  const countdownInterval = setInterval(function() {
    seconds--;

    if (seconds < 0) {
      minutes--;
      seconds = 59;
    }

    if (minutes < 0) {
      hours--;
      minutes = 59;
    }

    if (hours < 0) {
      // Countdown completed
      clearInterval(countdownInterval);
      timerElement.text('Timer Expired');
      localStorage.removeItem('countdownHours');
      localStorage.removeItem('countdownMinutes');
      localStorage.removeItem('countdownSeconds');
    } else {
      // Store the current time in localStorage
      localStorage.setItem('countdownHours', hours);
      localStorage.setItem('countdownMinutes', minutes);
      localStorage.setItem('countdownSeconds', seconds);

      // Update the display
      displayTime(hours, minutes, seconds);
    }
  }, 1000);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["discont-custom-section"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
  const timerElement = $('.countdown-timer .timer');
  const hoursElement = timerElement.find('.hours');
  const minutesElement = timerElement.find('.minutes');
  const secondsElement = timerElement.find('.seconds');

  // Get initial values from Shopify customizer settings
  let hours = parseInt(hoursElement.text());
  let minutes = parseInt(minutesElement.text());
  let seconds = parseInt(secondsElement.text());

  // Start the countdown timer
  const countdownInterval = setInterval(function() {
    seconds--;

    if (seconds < 0) {
      minutes--;
      seconds = 59;
    }

    if (minutes < 0) {
      hours--;
      minutes = 59;
    }

    if (hours < 0) {
      // Countdown completed
      clearInterval(countdownInterval);
      timerElement.text('Timer Expired');
    } else {
      // Update the display
      hoursElement.text(hours.toString().padStart(2, '0'));
      minutesElement.text(minutes.toString().padStart(2, '0'));
      secondsElement.text(seconds.toString().padStart(2, '0'));
    }
  }, 1000);
});

  } catch(e) { console.error(e); }
})();
})();
